import StandardRow, { BaseTableRowProps } from './StandardRow';
import ExpandableRow from './ExpandableRow';

export const DataTableRow = (props: BaseTableRowProps) => {
  const nestedLayout = Boolean(props.expandedContent || props.isNested);

  if (nestedLayout) {
    return <ExpandableRow {...props} />;
  }

  return <StandardRow {...props} />;
};

export default DataTableRow;
